import {ChangeDetectorRef, Component, ComponentFactoryResolver, ViewChild,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {Contract} from "../../../model/exchange/contract";
import {ExchangeContractService} from "../../../services/exchange/exchange-contract.service";
import {TableRequest} from 'src/app/model/api/table-request';
import {CrudTableComponent} from "../../../crystal-elements/crud/crud-table.component";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class ContractComponent extends CrudBaseComponent<Contract> {

  //fields
  exchanges: FieldRecord<any>[]
  currencies: FieldRecord<any>[]
  contractTypes: FieldRecord<any>[]
  seriesSchedules: FieldRecord<any>[]
  optionTypes: FieldRecord<any>[]

  @ViewChild('ccCrudTable')
  public ccCrudTable: CrudTableComponent;

  constructor(cdref: ChangeDetectorRef,
              contractService: ExchangeContractService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = contractService;
    this.newRecord = new Contract();
    this.newRecord.$type = 'WebContract';
    // const request = new TableRequest({}
    //   // {"filters":{"exchangeCode":[{"value":"IFEU","matchMode":"contains","operator":"and"}],"code":[{"value":null,"matchMode":"contains","operator":"and"}],"type":[{"value":null,"matchMode":"contains","operator":"and"}],"contractUnit":[{"value":null,"matchMode":"contains","operator":"and"}],"description":[{"value":null,"matchMode":"contains","operator":"and"}],"currency":[{"value":null,"matchMode":"contains","operator":"and"}]},"globalFilter":null}
    // );
    // request.globalFilter = 'IFEU';
    // // this.ccCrudTable.ccTable.setFiltersAndSort(request);
    // this.tableCurrentRequest = request
    this.tableCurrentRequest = new TableRequest({});
    this.tableCurrentRequest.sortOrder = 1;
    this.tableCurrentRequest.sortField = 'id';
    this.tableCurrentRequest.filters = [];
    // this.tableCurrentRequest.filters.push({
    //   "field": "exchangeCode",
    //   "value": "IFEU",
    //   "matchMode": "contains",
    //   "operator": "and"
    // }, {
    //   "field": "type",
    //   "value": "FUTURE",
    //   "matchMode": "contains",
    //   "operator": "and"
    // });
    this.prepareForEdit = this.prepareRecordForEdit;
    this.prepareForClone = this.prepareRecordForClone;
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    queueMicrotask(() => {
      // const request = new TableRequest({globalFilter:{"value":"IFEU","matchMode":"contains","operator":"and"}}
      //   // {"filters":{"exchangeCode":[{"value":"IFEU","matchMode":"contains","operator":"and"}],"code":[{"value":null,"matchMode":"contains","operator":"and"}],"type":[{"value":null,"matchMode":"contains","operator":"and"}],"contractUnit":[{"value":null,"matchMode":"contains","operator":"and"}],"description":[{"value":null,"matchMode":"contains","operator":"and"}],"currency":[{"value":null,"matchMode":"contains","operator":"and"}]},"globalFilter":null}
      // );
      // // request.globalFilter = 'IFEU';
      this.ccCrudTable.ccTable.setFiltersAndSort(this.tableCurrentRequest);
      // this.tableCurrentRequest = request
    });
  }

  prepareRecordForEdit() {
    if (this.formRecord) {
      this.formRecord.$type = 'WebContract';
    }
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.id = undefined;
      this.formRecord.$type = 'WebContract';
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'exchangeCode',
        width: 150,
        icon: (record: any) => {
          const exchField = this.exchanges ? this.exchanges.find(field => field.value
            && field.value.code === record.exchangeCode) : undefined;
          if (exchField && exchField.value) {
            return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          } else {
            return 'fas fa-globe-europe';
          }
        }
      },
      {
        field: 'code',
        width: 100,
      },
      {
        field: 'type',
        width: 100,
        notSortable: true,
        notFilterable: true,
      },
      {
        field: 'contractUnit',
        width: 100,
      },
      {
        field: 'description',
        width: 250,
      },
      {
        field: 'currency',
        width: 100,
        icon: record => 'cc-ico',
        iconValue: record => {
          const currField = this.currencies ? this.currencies.find(value => value.id === record.currency) : undefined;
          if (currField)
            return currField.value;
          return ''
        }
      },
      {
        field: 'optionType',
        width: 100,
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'exchangeCode',
            required: true,
            filter: true,
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.exchanges,
            icon: (ig: any) => {
              const exchField = this.exchanges ? this.exchanges.find(field => field.value && field.value.code === ig) : undefined;
              if (exchField && exchField.value) {
                return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              } else {
                return 'fas fa-globe-europe';
              }
            }
          },
          {
            field: 'code',
            required: true,
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'type',
            required: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.contractTypes,
          },
          {
            field: 'description',
            column: 8,
            type: TYPE.TEXT
          },
          {
            field: 'assetClass',
            column: 4,
            type: TYPE.TEXT
          }]
      },
      {
        group: 'info',
        fields: [
          {
            field: 'contractUnit',
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'contractSize',
            column: 3,
            type: TYPE.INTEGER
          }]
      },
      {
        group: 'details',
        fields: [
          {
            field: 'tickValue',
            column: 3,
            type: TYPE.DECIMAL
          },
          {
            field: 'contractValue',
            column: 3,
            type: TYPE.INTEGER
          },
          {
            field: 'currency',
            required: true,
            filter: true,
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.currencies,
            icon: id => 'cc-ico',
            iconValue: id => {
              const currField = this.currencies && this.currencies.find(value => value.id === id) ?
                this.currencies.find(value => value.id === id) : undefined;
              if (currField)
                return currField.value;
              return ''
            }
          },
          {
            field: 'pricePrecision',
            column: 3,
            type: TYPE.DECIMAL
          }]
      },
      {
        group: 'option',
        hidden: record => record.type != Contract.ContractType.OPTION,
        fields: [
          {
            field: 'strikePrecision',
            column: 3,
            type: TYPE.DECIMAL
          },
          {
            field: 'schedule',
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.seriesSchedules,
          },
          {
            field: 'optionType',
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.optionTypes,
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;
    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exchanges = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 2;
    });
    this.commonFieldService.getCurrencies(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.currencies = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 2;
    });
    this.contractTypes = [];
    for (let key in Contract.ContractType) {
      this.contractTypes.push(new FieldRecord(key, key.toLowerCase()))
    }
    this.seriesSchedules = [];
    for (let key in Contract.SeriesSchedule) {
      this.seriesSchedules.push(new FieldRecord(key, key.toLowerCase()))
    }
    this.optionTypes = [];
    for (let key in Contract.OptionType) {
      this.optionTypes.push(new FieldRecord(key, key.toLowerCase()))
    }
  }

  onFormShow() {
  }
}
